
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as health6wWID6oetb2OMxfpoBKy2TGrP9rHi9xKD5kmvBxXxw8Meta } from "/var/www/paribu.com/pages/health.vue?macro=true";
import { default as indexDxGp2y7v_456StdaFVHGIGry37IelKGrox57kLSzUEaZ4Meta } from "/var/www/paribu.com/pages/index/index.vue?macro=true";
import { default as indextm2xW4BpDQvQZQQj3WPih1zxjqF5PQoDxlg6qhffef4Meta } from "/var/www/paribu.com/pages/search/index.vue?macro=true";
import { default as indexRUlGS09BRyHZMTZT7BHMFDBlOpIYUp0m8OFSJ_2M6OkMeta } from "/var/www/paribu.com/pages/status/index.vue?macro=true";
import { default as index2EaOLox5VLnl6O_lwmBA_45X9m_45uZTyET63ZeCXm_3_45rkMeta } from "/var/www/paribu.com/pages/ticket/index.vue?macro=true";
import { default as indexnM7HaVxU_45aINAQ49J3J1unijyT2D9x6TVMjyIMSpV_UMeta } from "/var/www/paribu.com/pages/categories/index.vue?macro=true";
import { default as indexntw8Ec0BzvqRBFCeMZ9UvdabQo7avilJSoLbatLsh4IMeta } from "/var/www/paribu.com/pages/dictionary/index.vue?macro=true";
import { default as indexzhY8u1wEAPlHSs6RvqF_K0fBzRw_M2WS_bmub_45Tj4O4Meta } from "/var/www/paribu.com/pages/announcement/index.vue?macro=true";
import { default as indexZ_IPUFeeU_fLvB7Xl2YdNZKMveqLHuyLt6m5_Zfj_gkMeta } from "/var/www/paribu.com/pages/status/[detail]/index.vue?macro=true";
import { default as indexgtgPq_HmQykZo3mVd45WLskBpTZvNyyq3gTY4ip7brAMeta } from "/var/www/paribu.com/pages/content/[detail]/index.vue?macro=true";
import { default as indexpyWoRaVbJJ5pFq_45hqPIE4oEapjhgtkhLVy5fuoPlJ18Meta } from "/var/www/paribu.com/pages/categories/[detail]/index.vue?macro=true";
import { default as indexAmD4cKQtFR8NE0Kst_45BjEdZMxrzVNTVyco7CTbANeuUMeta } from "/var/www/paribu.com/pages/dictionary/[detail]/index.vue?macro=true";
import { default as index_45KP2qj4qM2POr_zsKV8_45sDkjYiLQkKT0nJSXqFdOVpQMeta } from "/var/www/paribu.com/pages/announcement/[detail]/index.vue?macro=true";
import { default as _91catch_45categories_45or_45content_93KF_1yEsg_UakdQn0Stwac26zHGulzFajlhaFegeW6NkMeta } from "/var/www/paribu.com/pages/[catch-categories-or-content].vue?macro=true";
import { default as language_45preferenceswwSBbGGh_45PjGQ_45g9Bk0M5lNe2LeRkbPWj1Hn2w2OoD8Meta } from "/var/www/paribu.com/pages/settings/language-preferences.vue?macro=true";
export default [
  {
    name: "health",
    path: "/health",
    component: () => import("/var/www/paribu.com/pages/health.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexDxGp2y7v_456StdaFVHGIGry37IelKGrox57kLSzUEaZ4Meta || {},
    component: () => import("/var/www/paribu.com/pages/index/index.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: indextm2xW4BpDQvQZQQj3WPih1zxjqF5PQoDxlg6qhffef4Meta || {},
    component: () => import("/var/www/paribu.com/pages/search/index.vue")
  },
  {
    name: "status",
    path: "/status",
    meta: indexRUlGS09BRyHZMTZT7BHMFDBlOpIYUp0m8OFSJ_2M6OkMeta || {},
    component: () => import("/var/www/paribu.com/pages/status/index.vue")
  },
  {
    name: "ticket",
    path: "/ticket",
    meta: index2EaOLox5VLnl6O_lwmBA_45X9m_45uZTyET63ZeCXm_3_45rkMeta || {},
    component: () => import("/var/www/paribu.com/pages/ticket/index.vue")
  },
  {
    name: "categories",
    path: "/categories",
    meta: indexnM7HaVxU_45aINAQ49J3J1unijyT2D9x6TVMjyIMSpV_UMeta || {},
    component: () => import("/var/www/paribu.com/pages/categories/index.vue")
  },
  {
    name: "dictionary",
    path: "/dictionary",
    meta: indexntw8Ec0BzvqRBFCeMZ9UvdabQo7avilJSoLbatLsh4IMeta || {},
    component: () => import("/var/www/paribu.com/pages/dictionary/index.vue")
  },
  {
    name: "announcement",
    path: "/announcement",
    meta: indexzhY8u1wEAPlHSs6RvqF_K0fBzRw_M2WS_bmub_45Tj4O4Meta || {},
    component: () => import("/var/www/paribu.com/pages/announcement/index.vue")
  },
  {
    name: "status-detail",
    path: "/status/:detail()",
    meta: indexZ_IPUFeeU_fLvB7Xl2YdNZKMveqLHuyLt6m5_Zfj_gkMeta || {},
    component: () => import("/var/www/paribu.com/pages/status/[detail]/index.vue")
  },
  {
    name: "content-detail",
    path: "/content/:detail()",
    meta: indexgtgPq_HmQykZo3mVd45WLskBpTZvNyyq3gTY4ip7brAMeta || {},
    component: () => import("/var/www/paribu.com/pages/content/[detail]/index.vue")
  },
  {
    name: "categories-detail",
    path: "/categories/:detail()",
    meta: indexpyWoRaVbJJ5pFq_45hqPIE4oEapjhgtkhLVy5fuoPlJ18Meta || {},
    component: () => import("/var/www/paribu.com/pages/categories/[detail]/index.vue")
  },
  {
    name: "dictionary-detail",
    path: "/dictionary/:detail()",
    meta: indexAmD4cKQtFR8NE0Kst_45BjEdZMxrzVNTVyco7CTbANeuUMeta || {},
    component: () => import("/var/www/paribu.com/pages/dictionary/[detail]/index.vue")
  },
  {
    name: "announcement-detail",
    path: "/announcement/:detail()",
    meta: index_45KP2qj4qM2POr_zsKV8_45sDkjYiLQkKT0nJSXqFdOVpQMeta || {},
    component: () => import("/var/www/paribu.com/pages/announcement/[detail]/index.vue")
  },
  {
    name: "catchcategoriesorcontent",
    path: "/:catchcategoriesorcontent()",
    meta: _91catch_45categories_45or_45content_93KF_1yEsg_UakdQn0Stwac26zHGulzFajlhaFegeW6NkMeta || {},
    component: () => import("/var/www/paribu.com/pages/[catch-categories-or-content].vue")
  },
  {
    name: "settings-language-preferences",
    path: "/settings/language-preferences",
    meta: language_45preferenceswwSBbGGh_45PjGQ_45g9Bk0M5lNe2LeRkbPWj1Hn2w2OoD8Meta || {},
    component: () => import("/var/www/paribu.com/pages/settings/language-preferences.vue")
  }
]